import { axios } from "../../../packs/axios";

export const currentMerchantAPI = {
  GETProgramSettings() {
    const fields = ['program_type', 'points_per_visit', 'points_per_dollar', 'loyalty', 'points_expiration_type', 'points_expiration_interval'].join(',');

    return axios.get('/api/v3/current_merchant/info', {
      params: {
        fields
      }
    }).then(resp => resp.data);
  },
   /**
    * Retrieve cash per point settings
    * @returns {object} {dollars_per_point: 0.01, dollars_per_point_enabled: true, reward_pos_string: ""}
    */
  GETCashPerPointsSettings() {
    const fields = ['dollars_per_point', 'springpay_enabled', 'reward_pos_string'].join(',');

    return axios.get('/api/v3/current_merchant/info', {
      params: {
        fields
      }
    }).then(resp => resp.data);
  },
  /**
   * Retrieve all current merchant notification images
   * filtered by category and subcategory (optional)
   * @param {string} category
   * @param {string} subcategory
   * @returns {object} {shared_image: [], merchant_images: []}
   */
  getNotificationImages(category, subcategory = null) {
    let params = {
      category: category
    }

    if(subcategory) params = { ...params, subcategory: subcategory }

    return axios.get("/api/v3/current_merchant/notification_images", { params })
                .then(resp => resp.data)
  },
  PUTProgramSettings(id, data) {
    return axios.put(`/api/v3/current_merchant/${id}`, data);
  },
  GETGroups() {
    return axios.get(`/api/v3/groups`).then((resp) => resp.data);
  },
  GETSegments(id, page, search = '') {
    return axios.get(`/api/v3/groups/merchant_segments`, {
      params: {
        segment_id: id,
        page,
        search
      }
    }).then((resp => resp.data));
  },
  GETTaggings(context, page, search = '') {
    return axios.get(`/api/v3/groups/merchant_taggings`, {
      params: {
        context,
        page,
        search
      }
    }).then((resp => resp.data));
  },
  GETSegmentMisc(page, search = '') {
    return axios.get(`/api/v3/groups/merchant_segments`, {
      params: {
        misc: true,
        page, search
      }
    }).then((resp => resp.data));
  }
}
